/*eslint-disable*/ export const messages = JSON.parse("{\"modal.aria.back\":[\"Tilbake\"],\"modal.aria.close\":[\"Lukk\"]}");
//# sourceMappingURL=messages.mjs.map